module.exports = __webpack_public_path__ + "static/cowswap-1f604593c695085c23707f4173a51e38.png";